import { useSettingsQuery } from 'src/api/queries/userQueries';
import { PageBody, SaveChangesBar, SettingsNavigation } from 'src/components';
import ContentVersioningSetting from 'src/components/ContentVersioningSetting';

import styles from './styles.module.scss';

export const VersionSettings = () => {
  const { isLoading } = useSettingsQuery();

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        <ContentVersioningSetting />
      </PageBody>
    </div>
  );
};
